import { c as _c } from "react-compiler-runtime";
import { useState } from 'react';
import { COMMENT_LIST_PADDING_PX } from '../../../constants/sidebar';
const COMMENTER_FORM_HEIGHT = 190;
export const EMPTY_COMMENTER_HEIGHT = COMMENTER_FORM_HEIGHT + COMMENT_LIST_PADDING_PX * 2;
export default function useMiniCommenterSize() {
  "use memo";

  const $ = _c(3);
  const [miniCommenterSize, setMiniCommenterSize] = useState(EMPTY_COMMENTER_HEIGHT);
  const [additionalHeightForPopover, setAdditionalHeightForPopover] = useState(0);
  const finalSize = miniCommenterSize + additionalHeightForPopover;
  let t0;
  if ($[0] !== finalSize || $[1] !== miniCommenterSize) {
    t0 = {
      miniCommenterSize: finalSize,
      baseMiniCommenterSize: miniCommenterSize,
      setAdditionalHeightForPopover,
      onResizeMiniCommenter: setMiniCommenterSize
    };
    $[0] = finalSize;
    $[1] = miniCommenterSize;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}